import type { CategorySuggestion } from "@/hooks/useCanonicalCategoryMapping.types";

export const isCategoryBlocked = (s: CategorySuggestion): boolean =>
  !!s.mappedTo && !s.mappedTo.lastSyncFailed;
